

<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> 試験日程管理
              <div class="card-header-actions">
                <a
                  class="card-header-action"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <CButton size="sm" color="info" @click="showRecordModal({industry_id: 0}, 0, 'Create')">新規作成</CButton>
                </a>
              </div>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol sm="2">
                </CCol>
                <CCol sm="4">
                </CCol>
                <CCol sm="2">
                </CCol>
                <CCol sm="2">
                  <CSelect
                    label="都道府県"
                    :options="region"
                    v-model="select_place"
                    @update:value="search"
                    name="region"
                  />
                </CCol>
                <CCol sm="2">
                  <CSelect
                    label="業種"
                    :options="industryTypes"
                    v-model="select_industry"
                    @update:value="search"
                    name="industry_id"
                  />
                </CCol>
              </CRow>

              <CDataTable
                :hover="true"
                :striped="true"
                :items="items"
                :fields="fields"
                itemsPerPage="30"
                pagination
                sorter
                @update:sorter-value="sort"
                :tableFilter="true"
                @update:table-filter-value="search"
              >
                <template #industry_id="{item}">
                  <td> {{ industries[item.industry_id] }}</td>
                </template>

                <template #midle_category="{item}">
                  <td>
                    <span v-if='item.midle_category != null'>
                      {{ item.midle_category }}
                    </span>
                  </td>
                </template>
                <template #date="{item}">
                  <td>
                    <CLink :href="'/examination/' + item.id"> {{ formatDate(item.date) }}</CLink>
                  </td>
                </template>
                <template #region="{item}">
                    <td v-if='item.region != undefined'> {{ item.region }}</td>
                    <td v-else></td>
                </template>
                <template #address="{item}">
                    <div v-if='item.place_ids != undefined'>
                      <td>{{ getPlace(item.place_ids)}}</td>
                    </div>
                    <td v-else>
                      {{ item.place_name }}
                    </td>
                </template>
                <template #announce_date="{item}">
                  <td> {{formatDate(item.announce_date)}}</td>
                </template>
                <template #show_details="{item, index}">
                  <td class="py-2">
                    <CButton class="mr-2" color="dark" variant="outline" square size="sm" @click="showRecordModal(item, index)">編集</CButton>
                    <CButton color="danger" variant="outline" square size="sm" @click="showDeleteModal(item, index)">削除</CButton>
                  </td>
                </template>

                <template #under-table>

                  <CCol sm="12" class="text-center">
                    <paginate
                      :page-count="meta.total_pages"
                      :prev-text="'前へ'"
                      :next-text="'次へ'"
                      :click-handler="paging"
                      :container-class="'pagination'">
                    </paginate>
                  </CCol>
                </template>


              </CDataTable>
            </CCardBody>
          </CCard>
      </CCol>
    </CRow>

    <CModal
      :title="modalModeTitle()"
      :color="modalModeCss()"
      :show.sync="recordModal"
    >
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">試験の業種</label>
           <CSelect
             placeholder="問題の業種を選択してください"
             :class="{ 'hasError': $v.record.industry_id.$error }"
             :options="industryTypes"
             :value.sync="record.industry_id"
           />

           <small v-if="$v.record.industry_id.$error" class="errorLabel">業種名を入れてください</small>
         </CCol>

         <CCol sm="12">
           <label class="record-label">中カテゴリー</label>
           <CInput
            placeholder="例) コンクリート圧送"
            v-model="record.midle_category"
          />
         </CCol>

         <CCol sm="12">
           <label class="record-label pt-3">開催日時</label>
           <CInput label="試験開催日時" v-model="record.date"  placeholder="ex) 2022-07-01 10:00"/>

           <small v-if="$v.record.date.$error" class="errorLabel"> 開催日時を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">試験会場の国</label>
           <CSelect
             placeholder="問題の業種を選択してください"
             :class="{ 'hasError': $v.record.country.$error }"
             :options="countries"
             :value.sync="record.country"
           />
           <small v-if="$v.record.country.$error" class="errorLabel"> 開催国を入れてください</small>
         </CCol>

         <CCol sm="12" v-if='record.country == "日本"'>
           <label class="record-label pt-3">都道府県</label>
           <multiselect
                v-model="region_selected"
                :options="region"
                :multiple="true"
                :close-on-select="false"
                placeholder="複数選択可">
            </multiselect>
         </CCol>

         <CCol sm="12">
           <label class="record-label pt-3">開催会場</label>
           <div v-if='record.country == "日本" && place_option.length != 0'>
             <multiselect
                v-model="place_selected"
                :options="place_option"
                :multiple="true"
                :close-on-select="false"
                label="label"
                placeholder="複数選択可"
                track-by="value">
            </multiselect>
             <small v-if="isValidPlaceId" class="errorLabel"> 会場を選択してください</small>
           </div>

           <div v-else>
             <CInput  placeholder="会場名" v-model="record.place_name" class='mb-3' :class="{ 'hasError': isValidPlaceName }"/>
             <CInput  placeholder="会場の住所" v-model="record.address" :class="{ 'hasError': isValidAddress }"/>
             <small v-if="isValidPlaceName" class="errorLabel"> 会場名を入れてください</small><br>
             <small v-if="isValidAddress" class="errorLabel"> 会場の住所を入れてください</small>
           </div>

         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">試験の方式</label>
           <CInput placeholder="実施方法" v-model="record.exam_format"/>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">試験の申込URL</label>
           <CInput placeholder="申込URL" v-model="record.application_url"  required :class="{ 'hasError': $v.record.application_url.$error }"/>
           <small v-if="$v.record.application_url.$error" class="errorLabel"> 申し込みのURLを入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">試験当日の受付開始時間</label>
           <CInput label="試験開催日時" v-model="record.reception_start_time" />
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">試験当日の受付終了時間</label>
           <CInput label="試験開催日時" v-model="record.reception_end_time" />
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">試験の申込開始日時</label>
           <CInput label="試験開催日時" v-model="record.application_start_date" />
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">試験の申込締め切り日時</label>
           <CInput label="試験開催日時" v-model="record.application_end_date" />
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">合格発表日</label>
           <CInput label="試験開催日時" v-model="record.announce_date" />
           <small v-if="$v.record.announce_date.$error" class="errorLabel"> 合格発表日を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">合格発表場所(ホームページURL)</label>
           <CInput placeholder="https://test.com/...." v-model="record.announce_methods"/>
         </CCol>
       </CRow>

       <template #footer>
         <CButton size="sm" @click="hideRecordModal()">キャンセル</CButton>
         <CButton size="sm" color="info" @click="updateItem(mode, itemIndex)">登録</CButton>
       </template>
    </CModal>
    <CModal
      title="削除しますか？"
      color="danger"
      :show.sync="deleteModal"
    >
      <div class="text-center">
        <p>この試験日程を削除しますか？？</p>
        <p>削除してしまうと復元することはできません</p>
      </div>
      <template #footer>
        <CButton size="sm" @click="hideDeleteModal()">キャンセル</CButton>
        <CButton size="sm" color="danger" @click="deleteItem()">削除</CButton>
      </template>
    </CModal>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
//TODO: ぱんくず

import axios from 'axios';
import moment from 'moment-timezone';
import { required } from "vuelidate/lib/validators";
import { mapGetters } from 'vuex';
import Paginate from 'vuejs-paginate'

export default {
  name: 'Home',
  components: {
    Paginate
  },
  data() {
    return {
      items: [],
      place_selected: [],
      place_option: [],
      region_selected: [],
      dictPlaces: {},
      fields: [
        { key: 'id', label: ""},
        { key: 'date', label: "開催日時"},
        { key: 'country', label: "国"},
        { key: 'region', label: "都道府県"},
        { key: 'address', label: "会場"},
        { key: 'announce_date', label: "合格発表日"},
        { key: 'announce_methods', label: "合格発表方法"},
        { key: 'industry_id', label: "試験業種"},
        { key: 'midle_category', label: "中カテゴリー"},
        { key: 'show_details',  label: '',  _style: 'width:15%', sorter: false, filter: false}],
      recordModal: false,
      deleteModal: false,
      mode: "",
      isValidAddress: false,
      isValidPlaceName: false,
      isValidPlaceId: false,
      itemIndex: 0,
      page: 1,
      filter_cs: [],
      filter_vs: [],
      industryTypes: [] ,
      industries: {},
      meta: {},
      record: {},
      select_industry: "",
      select_place: '',
      sort_column: "id",
      sort_asc: "desc",
      word: "",
      places: {},
      countries: [
        "ベトナム",
        "ラオス",
        "マレーシア",
        "バングラデッシュ",
        "インド",
        "モンゴル",
        "カンボジア",
        "ネパール",
        "インドネシア",
        "タイ",
        "フィリピン",
        "ミャンマー",
        "ウズベキスタン",
        "パキスタン",
        "日本"
      ],
      region: [
        '',
        '北海道',
        '青森',
        '岩手',
        '宮城',
        '秋田',
        '山形',
        '福島',
        '茨城',
        '栃木',
        '群馬',
        '埼玉',
        '千葉',
        '東京',
        '神奈川',
        '新潟',
        "富山",
        '石川',
        '福井',
        '山梨',
        '長野',
        '岐阜',
        '静岡',
        '愛知',
        '三重',
        '滋賀',
        '京都',
        '大阪',
        '兵庫',
        '奈良',
        '和歌山',
        '鳥取',
        '島根',
        '岡山',
        '広島',
        '山口',
        '徳島',
        '香川',
        '愛媛',
        '高知',
        '福岡',
        '佐賀',
        "長崎",
        '熊本',
        '大分',
        '宮崎',
        '鹿児島',
        '沖縄',
      ],
      static_industry: {
        1: {'application': 'http://ac.prometric-jp.com/testlist/nc/index.html', 'pass': 'http://ac.prometric-jp.com/testlist/nc/index.html'},
        2: {'application': 'https://entry.j-bma.or.jp/jbma_entry/?form=JAPAN20210&function_id=0001', 'pass': 'https://www.j-bma.or.jp/qualification-training/announcement'},
        3: {'application': 'https://www.sswm.go.jp/exam_f/examination_index.html', 'pass': 'https://www.sswm.go.jp/exam_f/examination_result.html'},
        8: {'application': 'http://ac.prometric-jp.com/testlist/automobile/index.html', 'pass': 'https://www.jaspa.or.jp/mechanic/result'},
        10: {'application': 'https://caipt.or.jp/tokuteiginou/entryah/', 'pass': 'https://sys.caipt.or.jp'},
        11: {'application': 'http://ac.prometric-jp.com/testlist/agriculture/index.html', 'pass': 'http://ac.prometric-jp.com/testlist/agriculture/index.html'},
        12: {'application': 'http://ac.prometric-jp.com/testlist/fisheries/index.html', 'pass': 'http://ac.prometric-jp.com/testlist/fisheries/index.html'},
        13: {'application': 'https://otaff1.jp', 'pass': 'https://otaff1.jp/insyoku/'},
        14: {'application': 'https://otaff1.jp', 'pass': 'https://otaff1.jp/insyoku/'},
      }
    }
  },
  validations: {
    record: {
      industry_id: {required},
      country: {required},
      date: {required},
      announce_date: {required},
      application_url: {required}
    }
  },
  methods: {
    login () {
      this.$cognito.login(this.username, this.password)
        .then(result => {
          console.log(result)
          this.$router.replace('/home')
        })
        .then(err => {
          this.error = err
        })
    },
    getPlace(ids){
      var idList = ids.split(',')
      var result = ''
      idList.forEach(id =>{
        if(id != ''){
          if(this.dictPlaces[id] != undefined) {
            result += this.dictPlaces[id]['name'] + ' , '
          }
        }
      })
      return result.slice( 0, -2 )
    },
    sort: function(e) {
      this.sort_column = e.column
      this.sort_asc = (e.asc == true)? "asc" : "desc"
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/examinations?word=" + this.word + "&page=" + this.page + "&column=" + this.sort_column + "&direction=" + this.sort_asc + "&filter_columns=" + this.filter_cs.join(",") + "&filter_values=" + this.filter_vs.join(","), {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            this.items = response.data.examinations
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    paging: function(n) {
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/examinations?filter_columns=" + this.filter_cs.join(",") + "&filter_values=" + this.filter_vs.join(",") + "&page=" + n + "&column=id&direction=desc", {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            this.items = response.data.examinations
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    search: function(e, c) {
      this.word = ""
      if(c != undefined){
        this.filter_update(c.target.name, e)
      } else {
        this.word = e
      }
      if(e == "-") {
        this.word = ""
      }
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/examinations?filter_columns=" + this.filter_cs.join(",") + "&filter_values=" + this.filter_vs.join(",") + "&page=" + this.page + "&column=" + this.sort_column + "&direction=" + this.sort_asc, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.items = response.data.examinations
          this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    filter_update: function(k, v) {
      if(this.filter_cs.includes(k)) {
        var i = this.filter_cs.indexOf(k)
        if(v == "-") {
          this.filter_cs.splice(i, 1)
          this.filter_vs.splice(i, 1)
        } else {
          this.filter_cs[i] = k
          this.filter_vs[i] = v
        }
      } else {
        this.filter_cs.push(k)
        this.filter_vs.push(v)
      }
    },
    formatDate: function(d) {
      var dat = moment(d)
      if(dat.isValid()) {
        return moment(d).tz('Asia/Tokyo').format("YYYY年MM月DD日 HH:mm")
      } else {
        return d
      }
    },
    validator (val) {
      return val ? val.length >= 1 : false
    },
    modalModeCss: function() {
      return (this.mode == "Create")? "info" : "dark"
    },
    modalModeTitle: function() {
      return (this.mode == "Create")? "新規試験日程追加" : "編集"
    },
    showRecordModal: function(i, index, mode="Edit") {
      this.recordModal = true
      this.record = i
      if(mode == 'Edit'){
        this.region_selected = []
        this.place_selected = []
        var place_id_list = i.place_ids.split(',')
        var region_list = i.region.split(',')
        region_list.forEach(region =>{
          this.region_selected.push(region)
          this.places[this.record.industry_id][region].forEach(row =>{
            if(place_id_list.includes(String(row.value))){
              this.place_selected.push( row )
            }
          })
        })
      }
      this.mode = mode
      this.itemIndex = index

    },
    showDeleteModal: function(i, index) {
      this.deleteModal = true
      this.record = i
      this.itemIndex = index
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    hideDeleteModal: function() {
      this.deleteModal = false
    },
    isPlaceValidate(){
      if(this.place_selected.length == 0){
        if(this.record.address == undefined && this.record.place_name == undefined || this.record.address == '' && this.record.place_name == ''){
          this.isValidPlaceId = true
          this.isValidPlaceName = true
          this.isValidAddress = true
          return true
        }else if(this.record.address == undefined || this.record.address == ''){
          this.isValidAddress = true
          this.isValidPlaceName = false
          return true
        }
        else if(this.record.place_name == undefined || this.record.place_name == ''){
          this.isValidPlaceName = true
          this.isValidAddress = false
          return true
        }
        else{
          this.isValidPlaceId = false
          this.isValidPlaceName = false
          this.isValidAddress = false
          return false
        }
      }else{
        if(this.record.address == undefined && this.record.place_name == undefined || this.record.address == '' && this.record.place_name == ''){
          this.record.address = ''
          this.record.place_name = ''
          this.isValidPlaceName = false
          this.isValidAddress = false
          this.isValidPlaceId = false
          this.record.place_ids = ''
          this.place_selected.forEach(select =>{
            this.record.place_ids += select.value + ','
          })
          console.log(this.record.place_ids)
          return false
        }else{
          this.place_selected = []
          if(this.record.address == undefined || this.record.address == ''){
            this.isValidAddress = true
            this.isValidPlaceName = false
            return true
          }
          else if(this.record.place_name == undefined || this.record.place_name == ''){
            this.isValidPlaceName = true
            this.isValidAddress = false
            return true
          }
        }
      }
    },
    updateItem: function(mode="Create", index=0) {
      this.$v.record.$touch();
      if(this.isPlaceValidate()) return
      if(this.$v.record.$error) return

      this.record.region = this.region_selected.join()
      if(mode == "Create") {
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/examinations", {"examination": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            console.log(response.data)
            if(response.data.place_ids != undefined){
              this.place_selected.forEach(select =>{
                axios
                .post(process.env.VUE_APP_API_ENDPOINT + "/places_examinations",
                  {"place_examination": {'place_id': select.value, 'examination_id': response.data.id}}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
                .then(res => {
                  console.log(res)
                }).catch(er => {
                  this.errorNotify(er.response)
                })
              })
              this.recordModal = false
              this.items.push(response.data)
            // this.$router.go({path: this.$router.currentRoute.path, force: true})
            }else{
              this.recordModal = false
              this.items.push(response.data)
                // this.$router.go({path: this.$router.currentRoute.path, force: true})
            }
          }).catch(error => {
            this.errorNotify(error.response)
          })
      } else {
        axios
          .patch(process.env.VUE_APP_API_ENDPOINT + "/examinations/" + this.record.id, {"examination": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            if(response.data.place_ids != undefined){
              this.place_selected.forEach(select =>{
                axios
                .post(process.env.VUE_APP_API_ENDPOINT + "/places_examinations/" + this.record.id,
                  {"place_examination": {'place_id': select.value, 'examination_id': response.data.id}}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
                .then(res => {
                  console.log(res)
                }).catch(er => {
                  this.errorNotify(er.response)
                })
              })
              this.recordModal = false
              this.items[index] = this.record
            }else{
              this.recordModal = false
              this.items[index] = this.record
            }
            this.recordModal = false

          }).catch(error => {
            this.errorNotify(error.response)
          })
      }
    },
    deleteItem: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/examinations/" + this.record.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.items.splice(this.itemIndex, 1)
          this.hideDeleteModal()
        }).catch(error => {
          this.errorNotify(error.response)
        })
    }
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/examinations", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        console.log(response.data.examinations)
          this.items = response.data.examinations
          this.meta = response.data.meta
            //this.items[i].date = moment(this.items[i].date).tz('Asia/Tokyo').format("YYYY/MM/DD HH:mm[JST]")
            //this.items[i].announce_date = moment(this.items[i].announce_date).tz('Asia/Tokyo').format("YYYY/MM/DD HH:mm[JST]")
            //this.items[i].reception_start_time = moment(this.items[i].reception_start_time).tz('Asia/Tokyo').format("HH:mm[JST]")
            //this.items[i].reception_end_time = moment(this.items[i].reception_end_time).tz('Asia/Tokyo').format("HH:mm")
            //this.items[i].application_start_date = moment(this.items[i].application_start_date).tz('Asia/Tokyo').format("YYYY/MM/DD HH:mm[JST]")
            //this.items[i].application_end_date = moment(this.items[i].application_end_date).tz('Asia/Tokyo').format("YYYY/MM/DD HH:mm[JST]")

      }).catch(error => {
          console.log(error)
          this.errorNotify(error.response)
      })

    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/industries", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          this.industryTypes = [{
              value: "",
              label: "",
          }]
          response.data.industries.forEach((i) => {
            this.industries[i.id] = i.name
            this.industryTypes.push({
                value: i.id,
                label: i.name
            })
          })
      }).catch(error => {
          console.log(error)
      })

    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/place_all", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          console.log('radfsad',response.data)
          this.places = response.data.format_place
          this.dictPlaces = response.data.dict
          console.log(this.dictPlaces)
          console.log(this.places)
      }).catch(error => {
          this.errorNotify(error.response)
      })
  },
  watch:{
    region_selected(){
      this.place_option = []
      this.region_selected.forEach(region =>{
        if(this.places[this.record.industry_id] != undefined){
          if(this.places[this.record.industry_id][region] != undefined){
            this.places[this.record.industry_id][region].forEach(place =>{
              this.place_option.push(place)
            })
          }
        }
      })
    },
    'record.industry_id': function(){
      if(this.static_industry[this.record.industry_id]){
        this.record.application_url = this.static_industry[this.record.industry_id]['application']
        this.record.announce_methods = this.static_industry[this.record.industry_id]['pass']
      }

    }
  },
    computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>
